<nav class="d-flex justify-content-between align-items-center mb-2" aria-label="breadcrumb">
    <ol class="breadcrumb mb-0">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
            Sample issuance to distributors
        </li>
    </ol>

    <button class="btn btn-primary btn-sm" (click)="generateExcel()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
            class="bi bi-file-earmark-spreadsheet-fill" viewBox="0 0 16 16">
            <path d="M6 12v-2h3v2z" />
            <path
                d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1M3 9h10v1h-3v2h3v1h-3v2H9v-2H6v2H5v-2H3v-1h2v-2H3z" />
        </svg>
        Generate Excel
    </button>
</nav>


<div class="row compact-content">

    <div class="col-xl-12">
        <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">
            <div class="row gx-3 gy-2 align-items-center">
                <!-- Title -->
                <div class="col-md-6 col-12">
                    <h5 class="mb-0 text-dark fw-bold">
                        Distributor Sample Report
                    </h5>
                </div>

                <!-- Generate + Filter Section -->
                <div
                    class="col-md-6 col-12 d-flex justify-content-md-end justify-content-start align-items-center gap-2 flex-wrap">
                    <mat-form-field (click)="picker.open()">
                        <mat-label>Filter by Issue Date</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate placeholder="Start Date" [(ngModel)]="sampleSearch.startdate"
                                readonly />
                            <input matEndDate placeholder="End Date" [(ngModel)]="sampleSearch.enddate"
                                (dateChange)="getAllSamples(null)" readonly />
                        </mat-date-range-input>
                        <div matSuffix class="d-flex align-items-center gap-1">
                            @if (sampleSearch.startdate || sampleSearch.enddate) {
                            <mat-icon (click)="clearDateRange()" class="clear-icon"
                                style="cursor: pointer;">close</mat-icon>
                            }
                            @else {

                            <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
                            }
                        </div>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </div>
            </div>

            <hr class="m-0 p-o">
            <hr class="m-0 p-o">

            <div class="row align-items-end ">
                <!-- Company -->
                @if (!isCompanyLoggedIn) {
                <div class="col-6 col-md-3 col-lg-3">
                    <ng-select [items]="allCompanies" bindLabel="name" bindValue="_id" placeholder="Filter by Company"
                        [(ngModel)]="sampleSearch.company" name="company" (change)="getAllSamples(null)">
                    </ng-select>
                </div>
                }

                <!-- Category -->
                <div class="col-6 col-md-3 col-lg-3">
                    <ng-select [items]="allCategoriesMini" bindLabel="name" bindValue="_id"
                        placeholder="Filter by Category" [(ngModel)]="sampleSearch.category" name="category"
                        (change)="getAllSamples(null)">
                    </ng-select>
                </div>

                <!-- Sample Name -->
                <div class="col-6 col-md-3 col-lg-3">
                    <mat-form-field class="dense w-100">
                        <mat-label>Search Sample Name</mat-label>
                        <input matInput [(ngModel)]="sampleSearch.name" name="name" (input)="onNameInputChange($event)">
                    </mat-form-field>
                </div>

                <!-- Barcode -->
                <div class="col-6 col-md-3 col-lg-3">
                    <mat-form-field class="dense w-100">
                        <mat-label>Search Barcode</mat-label>
                        <input matInput [(ngModel)]="sampleSearch.barCode" name="barCode"
                            (input)="onBarCodeInputChange($event)">
                    </mat-form-field>
                </div>

                <!-- City/State -->
                <div class="col-6 col-md-3 col-lg-3">
                    <mat-form-field class="dense w-100">
                        <mat-label>Search City/State</mat-label>
                        <input matInput [(ngModel)]="sampleSearch.cityState" name="cityState"
                            (input)="onCityStateInputChange($event)">
                    </mat-form-field>
                </div>

                <!-- Issue Type -->
                <div class="col-6 col-md-3 col-lg-3">
                    <ng-select [items]="issuedByOptions" bindLabel="label" bindValue="value"
                        placeholder="Issued By (Type)" [(ngModel)]="sampleSearch.issueType" name="issueType"
                        (change)="getAllSamples(null)">
                    </ng-select>
                </div>

                @if(sampleSearch.issueType==1){
                <!-- Issuer Distributor -->
                <div class="col-6 col-md-3 col-lg-3">
                    <ng-select [items]="allDistributors" bindLabel="distributorId.name" bindValue="distributorId._id"
                        placeholder="Issued By (Distributor)" [(ngModel)]="sampleSearch.issuerDistributorId"
                        name="issuerDistributorId" (change)="getAllSamples(null)">
                    </ng-select>
                </div>
                }


                <!-- Receiver Type -->
                <div class="col-6 col-md-3 col-lg-3">
                    <ng-select [items]="receiverTypeOptions" bindLabel="label" bindValue="value"
                        placeholder="Receiver Type" [(ngModel)]="sampleSearch.receiverType" name="receiverType"
                        (change)="getAllSamples(null)">
                    </ng-select>
                </div>

                <div class="col-6 col-md-3 col-lg-3">
                    <ng-select [items]="allDistributors" bindLabel="distributorId.name" bindValue="distributorId._id"
                        placeholder="Received By (Distributor)" [(ngModel)]="sampleSearch.receiverDistributorId"
                        name="receiverDistributorId" (change)="getAllSamples(null)">
                    </ng-select>
                </div>
            </div>
            <div class="table-responsive">
                <table mat-table [dataSource]="samplesDataSource" class="mat-table table-bordered compact-table">

                    <!-- Sr No -->
                    <ng-container matColumnDef="srno">
                        <th mat-header-cell *matHeaderCellDef class="text-nowrap">Sr. No</th>
                        <td mat-cell *matCellDef="let row; let index = index" class="text-center">
                            {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                        </td>
                    </ng-container>

                    <!-- Sample Name + Category -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="py-1 ">Sample Name</th>
                        <td mat-cell *matCellDef="let element" class="text-nowrap p-1 text-center">
                            <div class="text-start">{{ element.sampleId?.name }}</div>
                            <div class="text-start">
                                <small class="text-muted fs-7">{{ element.categoryId?.name }}</small>
                            </div>
                        </td>

                    </ng-container>

                    <!-- Sample Code -->
                    <ng-container matColumnDef="sampleCode">
                        <th mat-header-cell *matHeaderCellDef class="py-1">Bar Code</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{element.sampleId?.sampleCode}}</td>
                    </ng-container>

                    <!-- Company Name -->
                    <ng-container matColumnDef="companyName">
                        <th mat-header-cell *matHeaderCellDef class="py-1">Company</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{element.companyId?.name}}</td>
                    </ng-container>

                    <!-- Issue Type -->
                    <ng-container matColumnDef="issueType">
                        <th mat-header-cell *matHeaderCellDef class="py-1">Issued By</th>
                        <td mat-cell *matCellDef="let element" class="py-1">
                            @if( element.issueType === 0){
                            Company
                            }
                            @else if (element.issueType === 1) {
                            {{element.issuerDistributorId?.name}} <br>

                            <small>WholeSaler</small>
                            }
                            @else if (element.issueType ===2) {
                            {{element.issuerDistributorId?.name}} <br>
                            <small>Retailer</small>
                            }

                        </td>
                    </ng-container>

                    <!-- Receiver Name -->
                    <ng-container matColumnDef="receiverName">
                        <th mat-header-cell *matHeaderCellDef class="py-1">Receiver</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{element.receiverDistributorId?.name}}</td>
                    </ng-container>

                    <!-- Receiver Type -->
                    <ng-container matColumnDef="receiverType">
                        <th mat-header-cell *matHeaderCellDef class="py-1">Receiver Type</th>
                        <td mat-cell *matCellDef="let element" class="py-1">
                            {{ element.receiverType === 1 ? 'Wholesaler' : element.receiverType === 2 ? 'Retailer' :
                            'Other' }}
                        </td>
                    </ng-container>



                    <!-- Quantity Assigned -->
                    <ng-container matColumnDef="quantityAssigned">
                        <th mat-header-cell *matHeaderCellDef class="py-1">Assigned</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{element.quantityAssigned}}</td>
                    </ng-container>

                    <!-- Quantity Remaining -->
                    <ng-container matColumnDef="quantityRemaining">
                        <th mat-header-cell *matHeaderCellDef class="py-1">Remaining</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{element.quantityRemaining}}</td>
                    </ng-container>

                    <!-- Distributor Limit -->
                    <ng-container matColumnDef="distributorLimit">
                        <th mat-header-cell *matHeaderCellDef class="py-1">Limit</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{element.distributorLimit}}</td>
                    </ng-container>

                    <!-- Issued to Customer -->

                    <!-- City -->
                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef class="py-1">City/State</th>
                        <td mat-cell *matCellDef="let element" class="py-1">

                            @if (element.city|| element.state) {
                            {{element.city}},
                            {{element.state}}
                            }
                            @else {
                            -
                            }

                        </td>
                    </ng-container>



                    <!-- Created At -->
                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell *matHeaderCellDef class="py-1">Issue Date</th>
                        <td mat-cell *matCellDef="let element" class="py-1">
                            <div>{{ element.createdAt | date:'dd/MM/yyyy' }}</div>
                            <small>{{ element.createdAt | date:'hh:mm a' }}</small>
                        </td>
                    </ng-container>

                    <!-- Header and Row Definitions -->
                    <tr mat-header-row *matHeaderRowDef="sampleDisplayedColumns" class="t_head"></tr>
                    <tr mat-row *matRowDef="let row; columns: sampleDisplayedColumns;"></tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" [attr.colspan]="sampleDisplayedColumns.length">
                            No data available
                        </td>
                    </tr>

                </table>

            </div>
            <mat-paginator #paginator [length]="total" [pageSize]="10" [pageSizeOptions]="[10, 20, 50, 100]"
                (page)="getAllSamples($event)">
            </mat-paginator>
        </app-card>
    </div>
</div>